import React, { useState } from 'react';
import { Globe, Bell, Shield, CreditCard, Mail, Server, Key, Database, Smartphone, CheckCircle2, Save, Plus, Trash2, Edit2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminSettingsFullManagerProps {
  success: (msg: string) => void;
}
export function AdminSettingsFullManager({
  success
}: AdminSettingsFullManagerProps) {
  const [notifSettings, setNotifSettings] = useState<Record<string, boolean>>({
    newOrders: true,
    newAstrologers: true,
    pushNotifications: false,
    weeklyDigest: true,
    systemErrors: true,
    paymentFailures: true
  });
  const [paymentSystems, setPaymentSystems] = useState([{
    name: 'Stripe',
    status: true,
    fee: '2.9% + 30¢'
  }, {
    name: 'PayPal',
    status: true,
    fee: '3.49% + 49¢'
  }, {
    name: 'CloudPayments',
    status: false,
    fee: '2.8%'
  }, {
    name: 'Crypto (USDT)',
    status: true,
    fee: '1%'
  }]);
  const [services, setServices] = useState([{
    id: 'SRV-001',
    name: 'Натальная карта (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 490 ₽',
    status: 'active'
  }, {
    id: 'SRV-002',
    name: 'Соляр на год (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 990 ₽',
    status: 'active'
  }, {
    id: 'SRV-003',
    name: 'Консультация (30 мин)',
    category: 'Консультации',
    type: 'Видео',
    price: 'от 3 000 ₽',
    status: 'active'
  }, {
    id: 'SRV-004',
    name: 'Базовый курс астрологии',
    category: 'Курсы',
    type: 'Видеокурс',
    price: '15 000 ₽',
    status: 'active'
  }]);
  const handleSave = () => {
    success('Настройки успешно сохранены');
  };
  const renderToggle = (label: string, checked: boolean, onChange: () => void, description?: string) => <div className="flex items-start justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-7038">
      <div data-id="element-7039">
        <div className="text-sm font-medium text-slate-900" data-id="element-7040">{label}</div>
        {description && <div className="text-xs text-slate-500 mt-0.5" data-id="element-7041">{description}</div>}
      </div>
      <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ml-4 ${checked ? 'bg-indigo-500' : 'bg-slate-300'}`} onClick={onChange} data-id="element-7042">
        <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-7043" />
      </button>
    </div>;
  const generalSettings = <div className="space-y-6 max-w-3xl" data-id="element-7044">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7045">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7046">
          <Globe className="w-4 h-4 text-indigo-500" data-id="element-7047" /> Основная информация
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7048">
          <Input label="Название платформы" defaultValue="Astriqo" data-id="element-7049" />
          <Input label="Основной домен" defaultValue="astriqo.com" data-id="element-7050" />
          <Input label="Email поддержки" defaultValue="support@astriqo.com" data-id="element-7051" />
          <Input label="Телефон поддержки" defaultValue="+7 (800) 555-35-35" data-id="element-7052" />
          <div className="md:col-span-2" data-id="element-7053">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7054">
              Язык по умолчанию
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7055">
              <option value="ru" data-id="element-7056">Русский (RU)</option>
              <option value="en" data-id="element-7057">English (EN)</option>
              <option value="es" data-id="element-7058">Español (ES)</option>
            </select>
          </div>
        </div>
      </Card>

      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7059">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7060">
          <Database className="w-4 h-4 text-indigo-500" data-id="element-7061" /> Локализация и форматы
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-7062">
          <div data-id="element-7063">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7064">
              Основная валюта
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7065">
              <option value="RUB" data-id="element-7066">Российский рубль (₽)</option>
              <option value="USD" data-id="element-7067">Доллар США ($)</option>
              <option value="EUR" data-id="element-7068">Евро (€)</option>
            </select>
          </div>
          <div data-id="element-7069">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7070">
              Часовой пояс сервера
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7071">
              <option value="Europe/Moscow" data-id="element-7072">Europe/Moscow (UTC+3)</option>
              <option value="UTC" data-id="element-7073">UTC</option>
            </select>
          </div>
        </div>
      </Card>

      <div className="flex justify-end" data-id="element-7074">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7076" />} onClick={handleSave} data-id="element-7075">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const servicesSettings = <div className="space-y-6" data-id="element-7077">
      <div className="flex justify-between items-center" data-id="element-7078">
        <h3 className="text-sm font-bold text-slate-900" data-id="element-7079">
          Управление услугами
        </h3>
        <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-7081" />} data-id="element-7080">
          Добавить услугу
        </Button>
      </div>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-7082">
        <table className="w-full text-left" data-id="element-7083">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-7084">
            <tr data-id="element-7085">
              <th className="px-4 py-3 font-medium" data-id="element-7086">ID</th>
              <th className="px-4 py-3 font-medium" data-id="element-7087">Название</th>
              <th className="px-4 py-3 font-medium" data-id="element-7088">Категория</th>
              <th className="px-4 py-3 font-medium" data-id="element-7089">Тип</th>
              <th className="px-4 py-3 font-medium" data-id="element-7090">Базовая цена</th>
              <th className="px-4 py-3 font-medium" data-id="element-7091">Статус</th>
              <th className="px-4 py-3 text-right font-medium" data-id="element-7092">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-7093">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-7094">
                <td className="px-4 py-3 text-xs text-slate-500" data-id="element-7095">{s.id}</td>
                <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-7096">
                  {s.name}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-7097">
                  {s.category}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-7098">{s.type}</td>
                <td className="px-4 py-3 text-sm font-bold text-slate-900" data-id="element-7099">
                  {s.price}
                </td>
                <td className="px-4 py-3" data-id="element-7100">
                  <Badge variant={s.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-7101">
                    {s.status === 'active' ? 'Активна' : 'Скрыта'}
                  </Badge>
                </td>
                <td className="px-4 py-3 text-right" data-id="element-7102">
                  <div className="flex justify-end gap-2" data-id="element-7103">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Edit2 className="w-4 h-4 text-slate-400" data-id="element-7105" />} data-id="element-7104" />
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Trash2 className="w-4 h-4 text-rose-400" data-id="element-7107" />} data-id="element-7106" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
  const paymentSettings = <div className="space-y-6 max-w-4xl" data-id="element-7108">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7109">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7110">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7111">
            <CreditCard className="w-4 h-4 text-indigo-500" data-id="element-7112" /> Платёжные шлюзы
          </h3>
          <div className="space-y-1" data-id="element-7113">
            {paymentSystems.map((p, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-7114">
                <div data-id="element-7115">
                  <div className="text-sm font-medium text-slate-900" data-id="element-7116">
                    {p.name}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-7117">
                    Комиссия: {p.fee}
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-7118">
                  <Button variant="ghost" size="sm" className="text-xs h-7" data-id="element-7119">
                    Настроить
                  </Button>
                  <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ${p.status ? 'bg-emerald-500' : 'bg-slate-300'}`} onClick={() => {
                const newSystems = [...paymentSystems];
                newSystems[i].status = !newSystems[i].status;
                setPaymentSystems(newSystems);
                success(newSystems[i].status ? `${p.name} включен` : `${p.name} отключен`);
              }} data-id="element-7120">
                    <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${p.status ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-7121" />
                  </button>
                </div>
              </div>)}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7122">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7123">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-7124" /> Финансовые настройки
          </h3>
          <div className="space-y-4" data-id="element-7125">
            <Input label="Базовая комиссия платформы (%)" defaultValue="20" data-id="element-7126" />
            <Input label="Минимальная сумма вывода (₽)" defaultValue="5000" data-id="element-7127" />
            <Input label="Период холда средств (дней)" defaultValue="14" data-id="element-7128" />

            <div className="pt-4 border-t border-slate-100" data-id="element-7129">
              {renderToggle('Автоматические выплаты', false, () => {}, 'Выплаты астрологам 1 и 15 числа месяца')}
              {renderToggle('Разрешить возвраты клиентам', true, () => {}, 'В течение 24 часов после оплаты')}
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-7130">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7132" />} onClick={handleSave} data-id="element-7131">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const emailSettings = <div className="space-y-6 max-w-4xl" data-id="element-7133">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7134">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7135">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7136">
            <Mail className="w-4 h-4 text-indigo-500" data-id="element-7137" /> SMTP Настройки
          </h3>
          <div className="space-y-4" data-id="element-7138">
            <Input label="SMTP Сервер" defaultValue="smtp.sendgrid.net" data-id="element-7139" />
            <div className="grid grid-cols-2 gap-4" data-id="element-7140">
              <Input label="Порт" defaultValue="587" data-id="element-7141" />
              <div data-id="element-7142">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7143">
                  Шифрование
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-7144">
                  <option value="tls" data-id="element-7145">TLS</option>
                  <option value="ssl" data-id="element-7146">SSL</option>
                  <option value="none" data-id="element-7147">Нет</option>
                </select>
              </div>
            </div>
            <Input label="SMTP Логин" defaultValue="apikey" data-id="element-7148" />
            <Input label="SMTP Пароль" type="password" defaultValue="****************" data-id="element-7149" />
            <Input label="Отправитель (From Email)" defaultValue="noreply@astriqo.com" data-id="element-7150" />
            <Input label="Имя отправителя (From Name)" defaultValue="Astriqo" data-id="element-7151" />
            <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-7152">
              Отправить тестовое письмо
            </Button>
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7153">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7154">
            <Bell className="w-4 h-4 text-indigo-500" data-id="element-7155" /> Системные уведомления
          </h3>
          <div className="space-y-1" data-id="element-7156">
            {renderToggle('Уведомления о новых заказах', notifSettings.newOrders, () => setNotifSettings(p => ({
            ...p,
            newOrders: !p.newOrders
          })))}
            {renderToggle('Заявки на верификацию', notifSettings.newAstrologers, () => setNotifSettings(p => ({
            ...p,
            newAstrologers: !p.newAstrologers
          })))}
            {renderToggle('Ошибки системы (Критичные)', notifSettings.systemErrors, () => setNotifSettings(p => ({
            ...p,
            systemErrors: !p.systemErrors
          })))}
            {renderToggle('Ошибки платежей', notifSettings.paymentFailures, () => setNotifSettings(p => ({
            ...p,
            paymentFailures: !p.paymentFailures
          })))}
            {renderToggle('Еженедельный дайджест', notifSettings.weeklyDigest, () => setNotifSettings(p => ({
            ...p,
            weeklyDigest: !p.weeklyDigest
          })))}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-7157">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7159" />} onClick={handleSave} data-id="element-7158">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const securitySettings = <div className="space-y-6 max-w-4xl" data-id="element-7160">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7161">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7162">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7163">
            <Shield className="w-4 h-4 text-indigo-500" data-id="element-7164" /> Политики безопасности
          </h3>
          <div className="space-y-1" data-id="element-7165">
            {renderToggle('Двухфакторная авторизация (2FA)', true, () => {}, 'Обязательно для всех администраторов')}
            {renderToggle('Логирование всех входов', true, () => {}, 'Сохранять IP и User-Agent')}
            {renderToggle('Защита от брутфорса', true, () => {}, 'Блокировка после 5 неудачных попыток')}
            {renderToggle('Принудительная смена пароля', false, () => {}, 'Каждые 90 дней')}
            {renderToggle('Ограничение сессий', true, () => {}, 'Не более 3 активных сессий на пользователя')}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7166">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-7167">
            <Key className="w-4 h-4 text-indigo-500" data-id="element-7168" /> Ограничения доступа (IP)
          </h3>
          <div className="space-y-4" data-id="element-7169">
            <div data-id="element-7170">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-7171">
                Белый список IP для админки
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500 min-h-[100px]" placeholder="Введите IP адреса по одному в строке..." defaultValue="192.168.1.1&#10;10.0.0.0/24" data-id="element-7172" />
              <p className="text-[10px] text-slate-500 mt-1" data-id="element-7173">
                Оставьте пустым для доступа с любого IP
              </p>
            </div>
            {renderToggle('Блокировать Tor/VPN', false, () => {})}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-7174">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-7176" />} onClick={handleSave} data-id="element-7175">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const apiSettings = <div className="space-y-6 max-w-4xl" data-id="element-7177">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-7178">
        <div className="flex justify-between items-center mb-4" data-id="element-7179">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-7180">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-7181" /> API Ключи
          </h3>
          <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-7183" />} data-id="element-7182">
            Создать ключ
          </Button>
        </div>

        <div className="space-y-4" data-id="element-7184">
          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-7185">
            <div className="flex justify-between items-start mb-2" data-id="element-7186">
              <div data-id="element-7187">
                <div className="text-sm font-bold text-slate-900" data-id="element-7188">
                  Mobile App API (Production)
                </div>
                <div className="text-xs text-slate-500" data-id="element-7189">
                  Создан: 12.05.2023 • Последнее использование: 5 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-7190">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-7191">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-7192">
                sk_live_51Mxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-7193">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-7194">
                <Trash2 className="w-4 h-4" data-id="element-7195" />
              </Button>
            </div>
          </div>

          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-7196">
            <div className="flex justify-between items-start mb-2" data-id="element-7197">
              <div data-id="element-7198">
                <div className="text-sm font-bold text-slate-900" data-id="element-7199">
                  OpenAI Integration Key
                </div>
                <div className="text-xs text-slate-500" data-id="element-7200">
                  Создан: 01.08.2023 • Последнее использование: 1 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-7201">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-7202">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-7203">
                sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-7204">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-7205">
                <Trash2 className="w-4 h-4" data-id="element-7206" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-7207">
      <div data-id="element-7208">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-7209">
          Настройки платформы
        </h2>
        <p className="text-sm text-slate-500" data-id="element-7210">
          Глобальные параметры работы системы
        </p>
      </div>

      <Tabs tabs={[{
      id: 'general',
      label: 'Общие',
      content: generalSettings
    }, {
      id: 'services',
      label: 'Услуги',
      content: servicesSettings
    }, {
      id: 'payments',
      label: 'Платежи',
      content: paymentSettings
    }, {
      id: 'email',
      label: 'Email',
      content: emailSettings
    }, {
      id: 'security',
      label: 'Безопасность',
      content: securitySettings
    }, {
      id: 'api',
      label: 'API',
      content: apiSettings
    }]} data-id="element-7211" />
    </div>;
}